import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { resendVerification } from '../features/auth/authApi';

export function CheckEmailPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') ?? '';
  const [resent, setResent] = useState(false);

  const resend = useMutation({
    mutationFn: () => resendVerification(email),
    onSuccess: () => setResent(true),
  });

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-paper-100 px-4 font-manuscript">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, #8c2d1e 1.5px, transparent 0)',
          backgroundSize: '28px 28px',
        }}
      />

      <div className="relative w-full max-w-sm">
        <Link to="/" className="mb-8 flex items-center justify-center gap-2.5">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full">
            <img src="/logo.png" alt={t('common.appName')} className="h-full w-full object-cover" />
          </span>
          <span className="font-display text-lg font-semibold text-manuscript-ink">{t('common.appName')}</span>
        </Link>

        <div className="rounded-sm border border-manuscript-line-strong bg-paper-50 p-8 text-center">
          <h1 className="font-display text-xl font-semibold text-manuscript-ink">
            {t('auth.checkEmail.title')}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-manuscript-ink-soft">
            {t('auth.checkEmail.body', { email })}
          </p>

          {resent ? (
            <p className="mt-6 text-sm font-medium text-seal-500">{t('auth.checkEmail.resent')}</p>
          ) : (
            <button
              type="button"
              disabled={resend.isPending || !email}
              onClick={() => resend.mutate()}
              className="mt-6 text-sm font-medium text-seal-500 hover:text-seal-400 disabled:opacity-50"
            >
              {resend.isPending ? t('common.loading') : t('auth.checkEmail.resend')}
            </button>
          )}

          <p className="mt-6 text-sm text-manuscript-ink-soft">
            <Link to="/login" className="font-medium text-seal-500 hover:text-seal-400">
              {t('auth.checkEmail.backToLogin')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
